/* eslint-disable react-hooks/exhaustive-deps */
import "./adverts.css";
import React, { useState } from "react";
import { Carousel, Col, Row } from "react-bootstrap";
import { useAdverts } from "./useAdverts";
import { AdvertCard } from "./AdvertCard";
import { useAuditAdvert } from "lib/analytics/auditEvents";

export const AdvertBanner = ({ className = "mx-0" }) => {
  let adverts = useAdverts();
  const [isShow, setShow] = useState(true);
  const [selectedAd, setSelectedAd] = useState(0);
  const hide = () => setShow(false);
  const next = () => setSelectedAd(selectedAd < adverts.length ? selectedAd + 1 : 0);

  if (!adverts || !adverts.length) return null;
  if (!isShow) return null;

  return (
    <Row className={className}>
      <AdvertCarousel adverts={adverts} hide={hide} next={next} />
    </Row>
  );
};

// Called by AdvertBanner
export const AdvertCarousel = ({ adverts = [] }) => {
  const [index, setIndex] = useState(0);
  const auditAdvertView = useAuditAdvert(adverts);

  const handleSelect = (index) => {
    setIndex(index);
    auditAdvertView(index);
  };

  return (
    <Col lg={parseLgWidth(adverts[0].width)} md={parseMdWidth(adverts[0].width)} sm={12} className="d-flex pb-3 px-0">
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        controls={false}
        className="mb-0 h-100 w-100 shadow"
        interval={2500}
      >
        {adverts.map(renderCarouselItem)}
      </Carousel>
    </Col>
  );
};

// only carousel items have double/triple height, tileviews adverts do not.
const renderCarouselItem = (advert, index) => (
  <Carousel.Item key={index} className="mb-3 h-100 w-100" style={{ minHeight: parseHeight(advert.height) }}>
    <AdvertCard {...advert} />
  </Carousel.Item>
);

const parseLgWidth = (width) => {
  if (Number.isInteger(width)) return width;
  else if (width === "double") return 8;
  else if (width === "triple") return 12;
  else return 12;
};
const parseMdWidth = (width) => {
  if (Number.isInteger(width)) return width;
  else if (width === "double") return 12;
  else if (width === "triple") return 12;
  else return 12;
};

const parseHeight = (height) => {
  if (!height) return "100%";
  if (height === "double") return "500px";
  if (height === "triple") return "750px";
};
